import { get, post, put, del, patch } from "../common/apiClient";

const PATH = "/vocabulary";

export const getVocabularies = (params = {}) => {
  const { page = 1, limit = 20, q = "", hskLevel = "", topicId = "" } = params;
  return get(`${PATH}?page=${page}&limit=${limit}&q=${q}&hskLevel=${hskLevel}&topicId=${topicId}`);
};

export const createVocabulary = (data) => post(PATH, data);

export const updateVocabulary = (id, data) => put(`${PATH}/${id}`, data);

export const deleteVocabulary = (id) => del(`${PATH}/${id}`);

export const toggleFavorite = (id, isFavorite) =>
  put(`${PATH}/${id}`, { isFavorite });

export const getReviewCards = (topicId = "") =>
  get(`${PATH}/review${topicId ? `?topicId=${encodeURIComponent(topicId)}` : ""}`);

export const reviewVocabulary = (id, action) =>
  patch(`${PATH}/${id}/review`, { action });

export const getLearnCounts = (topicId = "") =>
  get(`${PATH}/learn-counts${topicId ? `?topicId=${encodeURIComponent(topicId)}` : ""}`);

export const getVocabStats = () => get(`${PATH}/stats`);

export const setLearnStatus = (id, learnStatus) =>
  patch(`${PATH}/${id}/learn`, { learnStatus });

export const importVocabulary = (rows, topicId = null) =>
  post(`${PATH}/import`, { rows, topicId });
